import { ModuleWithProviders, NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CalendarFooterButtonComponent } from './calendar-footer-button.component';
import { ToolbarModule } from 'primeng/toolbar';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import { HvlFormItemModule } from '@hvlng/framework-core/form';
import { ReactiveFormsModule } from '@angular/forms';
import { PrimengSharedModule } from '@hvlng/framework-core/shared';

@NgModule({
    declarations: [CalendarFooterButtonComponent],
    imports: [
        CommonModule,
        ToolbarModule,
        ButtonModule,
        TranslateModule,
        HvlFormItemModule,
        ReactiveFormsModule.withConfig({ callSetDisabledState: 'whenDisabledForLegacyCode' }),
        PrimengSharedModule,
    ],
    exports: [CalendarFooterButtonComponent],
})
export class CalendarFooterButtonModule {
    static forRoot(): ModuleWithProviders<CalendarFooterButtonModule> {
        return {
            ngModule: CalendarFooterButtonModule,
        };
    }
}
